import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapNumberHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Number;
    }
}

//# sourceMappingURL=WrapNumberHelper.js.map
